export enum AuthoritySPED {
  SPED_DOCUMENT_VIEW = '14.1',
  SPED_DOCUMENT_ADD = '14.2',
  SPED_DOCUMENT_EDIT = '14.3',
  SPED_DOCUMENT_REMOVE = '14.4',

  SPED_DOCUMENT_IMPORT_PURCHASE = '14.3.1',
  SPED_DOCUMENT_IMPORT_INVOICE = '14.3.2',
  SPED_DOCUMENT_REMOVE_PURCHASE = '14.3.3',
  SPED_DOCUMENT_REMOVE_INVOICE = '14.3.4',

  SPED_DOCUMENT_START_ANALYSIS = '14.5',
  SPED_DOCUMENT_CONSULT_ANALYSIS = '14.5.1',
  SPED_DOCUMENT_CONSULT_REPORT_ANALYSIS = '14.5.2',
  SPED_DOCUMENT_GENERATE_FILE = '14.5.3',
  SPED_DOCUMENT_CONSULT_GENERATE_FILE = '14.5.4',
  SPED_DOCUMENT_DOWNLOAD_GENERATE_FILE = '14.5.5',

  SPED_CONFIG_VIEW = '14.6',
  SPED_CONFIG_ADD = '14.6.1',
  SPED_CONFIG_EDIT = '14.6.2',
}
